module.exports = __webpack_public_path__ + "static/media/twitter-home-ice-blue.b4f40462.svg";